import { useDepositToPortfolioMutation } from 'hooks/mutations/Rewards/useDepositToPortfolioMutation'
import { useRewardsTracking } from 'pages/Rewards/hooks/useRewardsTracking'
import { BaseErrorResponse } from 'types/beneficiaries'
import { DepositToPortfolioRequest } from 'types/rewards'

export const useDepositPortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useRewardsTracking()
  const { mutate: depositToPortfolio, isPending: isDepositingToPortfolioPending } =
    useDepositToPortfolioMutation()

  const handleDepositToPortfolio = (data: DepositToPortfolioRequest) => {
    return depositToPortfolio(data, {
      onSuccess: () => {
        trackSuccess('allocate', {
          walletId: data.originator.walletId,
          amount: data.originator.amount,
        })
        onSuccess?.()
      },
      onError: (error: BaseErrorResponse) => {
        trackError('allocate', error, {
          walletId: data.originator.walletId,
          amount: data.originator.amount,
        })
        onError?.(error)
      },
    })
  }

  return {
    depositToPortfolio: handleDepositToPortfolio,
    isDepositingToPortfolioPending,
  }
}
